// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'
import { gsap, Power4 } from "gsap/all";

export default class HeroComponent extends Component {
  
  constructor(element) {
    super(element);
    this.ref = {
      image: null,
      title: null,
      text: null,
      subtitle: null,
      content: null,
      ctas: null,
      video: null,
    }
  }
  
  mount() {
    this.parallaxIn(this)

    const mobile_video = this.element.dataset.mobileVideo
    const desktop_video = this.element.dataset.desktopVideo
    if(mobile_video && desktop_video) {
      const source = document.createElement('source');
      source.setAttribute('type', 'video/mp4');

      if (window.innerWidth < 768) {
        source.setAttribute('src', mobile_video)
      } else {
        source.setAttribute('src', desktop_video)
      }
      console.log(this.ref.video);
      this.ref.video.appendChild(source);
    }
  }
  async unmount() {
    
    // await this.parallaxOut(this)
  }
  
  // parallaxOut() {
  //   gsap.to(this.ref.title, {
  //     color: 'red',
  //     duration: 0.1,
  //   });
    
    
    
  // }
  parallaxIn() {
    
    if (this.ref.content) {
      gsap.from(this.ref.content, {
        opacity: 0,
        duration: 0.5,
        delay: 0.25,
      });
    }
    
    if (this.ref.ctas) {
      gsap.from(this.ref.ctas, {
        opacity: 0,
        y: 100,
        duration: 1.25,
        delay: 0.75,
      });
    }
    
    if (this.ref.subtitle) {
      gsap.from(this.ref.subtitle, {
        y: 100,
        duration: 1.5,
        delay: 0.33
      });
      gsap.from(this.ref.subtitle, {
        opacity: 0,
        duration: 0.75,
        delay: 0.33
      });
    }
    
    if (this.ref.title) {
      gsap.from(this.ref.title, {
        y: 100,
        duration: 0.75
      });
      gsap.from(this.ref.title, {
        opacity: 0,
        duration: 0.33
      });
    }
    
    if (this.ref.image) {
      gsap.from(this.ref.image, {
        scaleX:1.125, scaleY:1.125,
        duration: 4,
      });
      gsap.from(this.ref.image, {
        opacity: 0,
        duration: 1.5,
      });
    }

    if (this.ref.video) {
      gsap.from(this.ref.image, {
        scaleX:1.125, scaleY:1.125,
        duration: 4,
      });
      gsap.from(this.ref.image, {
        opacity: 0,
        duration: 1.5,
      });
    }
    
  }
  
  
}